const actions = {
	GET_MULTIPLE_CHOICE_SINGLE_ANSWER: 'GET_MULTIPLE_CHOICE_SINGLE_ANSWER',
	GET_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS: 'GET_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS',

	CREATE_NEW_QUESTION_MULTIPLE_CHOICE_SINGLE_ANSWER: 'CREATE_NEW_QUESTION_MULTIPLE_CHOICE_SINGLE_ANSWER',
	CREATE_NEW_QUESTION_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS: 'CREATE_NEW_QUESTION_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS',

	DELETE_MULTIPLE_CHOICE_SINGLE_ANSWER: 'DELETE_MULTIPLE_CHOICE_SINGLE_ANSWER',
	DELETE_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS: 'DELETE_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS',

	GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL: 'GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL',
	GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL_SUCCESS: 'GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL_SUCCESS',

	UPDATE_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL: 'UPDATE_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL',
	UPDATE_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL_SUCCESS: 'UPDATE_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getMultipleChoiceSingleAnswer: (model) => ({
		type: actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER,
		payload: { model },
	}),

	createQuesMultipleChoiceSingleAnswer: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_MULTIPLE_CHOICE_SINGLE_ANSWER,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getMultipleChoiceSingleAnswerDetail: (id) => ({
		type: actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL,
		payload: { id },
	}),

	updateMultipleChoiceSingleAnswerDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteMultipleChoiceSingleAnswer: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_MULTIPLE_CHOICE_SINGLE_ANSWER,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
